import React from 'react';
import { SupplementLandingPage } from './pages/SupplementLandingPage';
export function App() {
  return <SupplementLandingPage data-id="element-0" />;
}